import {createSlice} from "@reduxjs/toolkit";

const initialAuthState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  redirectTo: "/",
  lastError: null
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const authSlice = createSlice({
  name: "auth",
  initialState: initialAuthState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getCustomerById
    redirecting: (state, action) => {
      state.actionsLoading = false;
      state.redirectTo = action.payload.redirectTo;
      state.error = null;
    },
  }
});
